/**
 * Ingredient validation utilities
 * Pure functions for validating ingredient IDs
 */

/**
 * Validate an array of ingredient IDs
 * @param ids - Array of ingredient IDs to validate
 * @throws {Error} If IDs are invalid
 */
export function validateIngredientIds(ids: number[]): void {
  if (!ids || ids.length === 0) {
    throw new Error("At least one ingredient ID is required");
  }

  const hasInvalidIds = ids.some((id) => !Number.isInteger(id) || id <= 0);
  if (hasInvalidIds) {
    throw new Error("All ingredient IDs must be positive integers");
  }
}

/**
 * Check if an array of IDs is valid without throwing
 * @param ids - Array of ingredient IDs to check
 * @returns True if valid, false otherwise
 */
export function areIngredientIdsValid(ids: number[] | undefined): boolean {
  if (!ids || ids.length === 0) {
    return false;
  }

  return ids.every((id) => Number.isInteger(id) && id > 0);
}

